import { useSyncExternalStore, type ReactNode } from "react";

import { workspaceLocaleScope } from "./WorkspaceLocaleRuntime";

function readyPathFromDocument(): string {
  if (typeof document === "undefined") return "";
  return document.documentElement.dataset.kavooshLocaleReadyPath ?? "";
}

function subscribeReady(onStoreChange: () => void): () => void {
  if (typeof document === "undefined" || typeof MutationObserver === "undefined") return () => undefined;
  const observer = new MutationObserver(onStoreChange);
  observer.observe(document.documentElement, { attributes: true, attributeFilter: ["data-kavoosh-locale-ready-path"] });
  return () => observer.disconnect();
}

export function WorkspaceLocaleGate({ path, children }: { path: string; children: ReactNode }) {
  const readyPath = useSyncExternalStore(subscribeReady, readyPathFromDocument, () => path);
  const scope = workspaceLocaleScope(path);
  if (!scope) return <>{children}</>;
  if (readyPath !== scope) return <main className="admin-route-state" aria-busy="true" aria-label="Kavoosh" />;
  return <>{children}</>;
}
